module.exports = __webpack_public_path__ + "static/media/palette_from_color.20d47dab.mov";